import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Span, Spinner } from "../../../../widgets";
import { TextProperties, useTextProperties } from "./TextProperties";

import { DraftTextComponent } from "./DraftTextComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const TextComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, properties, error } = useTextProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Span {...properties} className={className}>{children}</Span>
}

Registry.addControl({
    id: "35c0815e-58a5-40e9-8ec8-97d1d1bdbf49",
    name: "Text",
    type: ControlType.Text,
    properties: TextProperties,
    component: TextComponent,
    draftComponent: DraftTextComponent
})
